import type { ReactNode } from 'react';
import { haptic } from '@/telegram';
import { cn } from '@/lib/utils';

/** Единый вид «таблетки» для категорий, дат и вариантов выбора. */
export function chipClass(active: boolean, className?: string): string {
  return cn(
    'inline-flex min-h-9 shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-full border px-3.5 text-[14px] font-medium transition-colors active:opacity-70',
    active
      ? 'border-transparent bg-primary text-primary-foreground'
      : 'border-transparent bg-card text-foreground',
    className,
  );
}

interface ChipProps {
  active?: boolean;
  onClick?: () => void;
  children: ReactNode;
  /** Что выбрано — для скринридера, если кнопка вне группы. */
  ariaPressed?: boolean;
  className?: string;
  disabled?: boolean;
}

export function Chip({
  active = false,
  onClick,
  children,
  ariaPressed,
  className,
  disabled = false,
}: ChipProps): JSX.Element {
  return (
    <button
      type="button"
      disabled={disabled}
      aria-pressed={ariaPressed ?? active}
      className={cn(chipClass(active, className), disabled && 'opacity-50')}
      onClick={() => {
        if (!onClick) return;
        haptic.select();
        onClick();
      }}
    >
      {children}
    </button>
  );
}

/** Лента чипов в одну строку с горизонтальной прокруткой — до края экрана. */
export function ChipRail({
  children,
  label,
  className,
}: {
  children: ReactNode;
  label: string;
  className?: string;
}): JSX.Element {
  return (
    <div
      className={cn('no-scrollbar -mx-4 flex gap-2 overflow-x-auto px-4', className)}
      role="group"
      aria-label={label}
    >
      {children}
    </div>
  );
}
